import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center font-sans dark:bg-black">
      <div className="w-full max-w-md">
        <Outlet />
      </div>
    </div>
  );
}
